import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ESPECIALIDADITEMS } from '../../utils/ConstantsMain';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  FormControlLabel,
  Checkbox,
  Button,
} from '@material-ui/core';
import ChipInput from 'material-ui-chip-input';
import { filterSubSpecialties, filterExtraSubs } from '../../utils/SubSpecialties'
import "./addSpecialties.scss";

const styles = () => ({
  form: {
    padding: 16,
    borderRadius: 4,
    margin: '20px 0 30px 0',
    border: '1px solid #e7e7e7',
    display: 'flex',
    flexDirection: 'column',
  },
  firstForm: {
    padding: 16,
    borderRadius: 4,
    margin: '10px 0 30px 0',
    border: '1px solid #e7e7e7',
    display: 'flex',
    flexDirection: 'column',
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
  },
  colorActiveCheckCommunity: {
    color: '#484848',
    fontSize: 16,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    margin: 0,
    paddingLeft: 0
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  TextField: {
    maxWidth: '536px',
    margin: '0 0 6px 0',
    width: '100%',
    "&:last-child": {
      margin: '20px 0 6px 0'
    },
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
      width: 296
    },
  },
  deleteActionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  deleteAction: {
    color: '#d74242',
    fontSize: 12,
    padding: 0,
    textTransform: 'capitalize',
    margin: '0 30px 0 0',
  },
  helperText: {
    marginLeft: 0
  },
  chip: {
    '&$focused': {
      backgroundColor: '#01395',
    }
  },
  contentTextCheck: {
    display: 'flex',
    flexDirection: 'row',
  },
  titleCheck: {
    margin: '2px 0 0 0',
    color: '#484848',
    fontWeight: 'normal',
    fontSize: 16,
  },
  subSpeContainer: {
    margin: '0 0 8px',
    borderBottom: '1px solid #c1c1c1'
  },
  subSpeTitle: {
    color: '#013957',
    fontSize: 16,
    fontWeight: 'bold',
  },
  '@media screen and (max-width: 768.98px)': {
    TextField: {
      width: '90%',
    },
  },
});

const LawyerSpecialtiesForm = props => {

  const {
    specialtyItem,
    specialtiesHelper,
    handleCancel, 
    touched,
    errors,
    classes,
    index,
    edit,
    subSpecialities,
    setFieldValue,
    localSpecialties,
    extraSubSpecialities,
    didCancel,
    setDidCancel,
  } = props;

  const deleteSubForm = () => {    
    specialtiesHelper.remove(index)
  };

  const [ checked, setChecked ] = useState(
    specialtyItem.subSpecialties
  )

  const [ subSpecialitiesData, setSubSpecialitiesData ] = useState([])
  const [ didRender, setDidRender ] = useState(false)
  const [ chips, setChips ] = useState([]);

  const handleAddChip = (chip, setFieldValue) => {
    let newChips = [...chips];
    newChips.push(chip)
    setChips(newChips);
    setFieldValue(`specialties[${index}].extraSubSpecialties`, newChips)
  }

  const handleDeleteChip = (chip, index) => {
    let newChips = [...chips];
    newChips.splice(index, 1)
    setFieldValue(`specialties[${index}].extraSubSpecialties`, newChips)
    setChips(newChips);
  }

  const handleChangeCheckCommunity = (event, elem, ind) => {
    setFieldValue(`specialties[${index}].subSpecialties[${ind}].${elem}`, event.target.checked)
    let newState = specialtyItem.subSpecialties
    newState[ind][`${elem}`] = event.target.checked
    setChecked(newState)
  }

  const handleChangeSpecialty = (e) => {
    setFieldValue(`specialties[${index}].specialty`, e.target.value)
    setSubSpecialitiesData(filterSubSpecialties(e.target.value))
    const mappedArray = filterSubSpecialties(e.target.value).map((elem, ind) => {
      setFieldValue(`specialties[${index}].subSpecialties[${ind}].${elem}`, elem)
      return {
        [`${elem}`]: true
      }
    })
    setChecked(mappedArray)
  }

  useEffect(() => {
    if (didCancel) {
      setSubSpecialitiesData([])
      setDidCancel(false)
    }

    if (edit && !didRender) {
      // Subespecialidades
      const data = filterSubSpecialties(specialtyItem.specialty)
      let newState = []
      data.forEach(elem => {
        let option = {}
        option[`${elem}`] = false
        newState.push(option)
        if (subSpecialities && subSpecialities.length) {
          subSpecialities.forEach(subElem => {
            let ind
            if (elem && subElem) {
              ind = newState.findIndex(el => {
                const newKey = Object.keys(el)
                return newKey[0] === subElem
              })
              if (ind >= 0) {
                newState[ind][`${subElem}`] = true
              }
            }
          })
        }
      })
      let newCheckboxOptions = []
      newState.forEach((elem, ind) => {
        const newKey = Object.keys(elem)
        setFieldValue(`specialties[${index}].subSpecialties[${ind}].${newKey[0]}`, elem[`${newKey[0]}`])
        newCheckboxOptions.push(newKey[0])
      })
      setSubSpecialitiesData(newCheckboxOptions)
      setChecked(newState)
      setDidRender(true)

      // Extrasubespecialidades
      const extraSubs = filterExtraSubs(specialtyItem.specialty, extraSubSpecialities)
      setFieldValue(`specialties[${index}].extraSubSpecialties`, extraSubs)
      setChips(extraSubs);
    }
  }, [didCancel, didRender, edit, extraSubSpecialities, index, localSpecialties, setDidCancel, setFieldValue, specialtyItem.specialty, subSpecialities])

  return (
    <div
      className={
        index && index !== 0 ?
        classes.form : classes.firstForm
      }
    >
      <FormControl
        classes={{ root: classes.TextField }}
        variant="outlined"
        error={touched.Items && errors.Items ? true : false}
      >
        <InputLabel
          htmlFor="select-multiple-checkbox"
          classes={{
            root: classes.inputLabelRoot,
            shrink: classes.inputLabelShrink,
          }}
        >
          {'Áreas de práctica*'}
        </InputLabel>
          <Select
            id={`specialties[${index}].specialty`}
            name={`specialties[${index}].specialty`}
            value={specialtyItem && specialtyItem.specialty ? specialtyItem.specialty : ''}
            onChange={(e) => handleChangeSpecialty(e)}
          >
            {ESPECIALIDADITEMS && ESPECIALIDADITEMS.map((item, index) => (
              <MenuItem key={index} value={item} >
                {item}
              </MenuItem>
            ))}
        </Select>
        {touched &&
        touched.specialty &&
        touched.specialty[index] &&
        touched.specialty[index].specialty &&
        errors &&
        errors.specialty &&
        errors.specialty[index].specialty ? (
          <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
            {errors.specialty[index].specialty}
          </FormHelperText>
        ) : (
          ''
        )}
      </FormControl>
      
      {subSpecialitiesData && subSpecialitiesData.length !== 0 ?
        <div className={classes.subSpeContainer}>
          <p className={classes.subSpeTitle}>Subáreas de práctica</p>
        </div> : null
      }

      {subSpecialitiesData && subSpecialitiesData.length !== 0 ?
        (subSpecialitiesData.map((elem, ind) => {
          return (
            <FormControlLabel
              classes={{ root: classes.FormControlLabelRoot }}
              key={ind}
              control={
                <Checkbox
                  name={`specialties[${index}].subSpecialties[${ind}].${elem}`}
                  checked={checked[ind][`${elem}`] ? true : false}
                  onChange={(e) => handleChangeCheckCommunity(e, elem, ind)}
                  label="Gilad Gray"
                  classes={{
                    root: classes.checkPadding,
                  }}
                />
              }
              label={
                <div className={classes.colorActiveCheckCommunity}>
                  <div className={classes.contentTextCheck}>
                    <p className={classes.titleCheck}>{elem}</p>
                  </div>
                </div>
              }
            />
          )
        })) : null
      }

      {specialtyItem.specialty ?
        <ChipInput
          id={`specialties[${index}].extraSubSpecialties`}
          name={`specialties[${index}].extraSubSpecialties`}
          value={chips}
          label="Otras"
          onAdd={(chip) => handleAddChip(chip, setFieldValue)}
          onDelete={(chip, index) => handleDeleteChip(chip, index)}
          variant="outlined"
          classes={{
            root: classes.TextField,
            helperText: classes.helperText,
            chip: classes.chip
          }}
          blurBehavior='clear'
          helperText={'Separa tus subespecialidades por una coma (,)'}
          newChipKeyCodes = {[188]} //comma
        /> : null
      }
      
      {index && index !== 0 ?
        <div className={classes.deleteActionContainer}>
          <Button
            key={index}
            component="span"
            type="button"
            onClick={index && index !== 0 ? deleteSubForm : handleCancel}
            className={classes.deleteAction}
          >
            Eliminar
          </Button>
        </div> : null
      }
    </div>
  )
};

const mapStateToProps = state => ({
  subSpecialities: state.authClient.subSpecialities,
  extraSubSpecialities: state.authClient.extraSubSpecialities,
})

const LawyerSpecialtiesFormCompose = compose(
  withStyles(styles),
  connect(mapStateToProps)
)(LawyerSpecialtiesForm)

export default LawyerSpecialtiesFormCompose;
